const LEAD_ID_KEY = "zoho_lead_id";
const LINK_COUNT_KEY = "interview_link_count";

export const saveInterviewSession = (
  encodedZohoLeadId,
  encodedInterviewLinkSendCount
) => {
  if (encodedZohoLeadId) {
    sessionStorage.setItem(LEAD_ID_KEY, encodedZohoLeadId);
  }

  if (encodedInterviewLinkSendCount) {
    sessionStorage.setItem(LINK_COUNT_KEY, encodedInterviewLinkSendCount);
  }
};

export const getInterviewSession = () => ({
  encoded_zoho_lead_id: sessionStorage.getItem(LEAD_ID_KEY),
  encoded_interview_link_send_count: sessionStorage.getItem(LINK_COUNT_KEY),
});

export const getInterviewStorageSuffix = () => {
  const { encoded_zoho_lead_id, encoded_interview_link_send_count } =
    getInterviewSession();

  if (encoded_zoho_lead_id && encoded_interview_link_send_count) {
    return `${encoded_zoho_lead_id}_${encoded_interview_link_send_count}`;
  }

  const match = window.location.pathname.match(
    /\/interview_panel\/([^/]+)\/([^/]+)/
  );

  if (match?.[1] && match?.[2]) {
    return `${match[1]}_${match[2]}`;
  }

  return "default";
};
